import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import { DASHBOARD_RESOURCES } from 'constant';
import { dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { IHappyHourTemplate } from '../../interfaces';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateHappyHour } = useService();

	const createHappyHour = (createdData: { happyHourData: IHappyHourTemplate }) => {
		setShowLoader(true);
		const { happyHourData } = createdData;

		requestCreateHappyHour(app.appName, { ...happyHourData }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the happy hour template', { type: 'error' });
					setShowLoader(false);
					return;
				}
				showAlert('Happy Hour Template created');
				setShowLoader(false);
				history.push({
					pathname: `/dashboard/${DASHBOARD_RESOURCES.happyHour}/list`
				});
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: IHappyHourTemplate) => {
		createHappyHour(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
